import type { GoogleAdsState } from './GoogleAds.types';

export const INIT_STATE: GoogleAdsState = {
  authenticationUrl: '',
  loading: false,
  validating: false,
  adAccounts: [],
  adAccountStatuses: {},
};
